var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_53",
    "data-name": "Group 53",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M10,20A10,10,0,1,1,20,10,10.012,10.012,0,0,1,10,20Zm0-9.116h0l3.093,3.093.884-.884L10.884,10l3.095-3.095-.884-.884L10,9.116l-3.1-3.1L6.019,6.9l3.1,3.1-3.1,3.095.884.884L10,10.886Z",
    transform: "translate(0)",
    fill: "#f5525f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBig);
export default __webpack_public_path__ + "static/media/error-big.d5690e5e5b2b371793582d1e32a11aa6.svg";
export { ForwardRef as ReactComponent };